import React, { createContext, useCallback, useEffect, useState } from 'react'
import Axios from 'axios'
import { API_URI } from '../../config'

const initialState = {
    dashboardData: null,
    loading: true,
    error: null,
    refetch: () => {},
}

const DashboardContext = createContext(initialState)

export const DashboardProvider = ({ children }) => {
    const [dashboardData, setDashboardData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchDashboard = useCallback(async () => {
        const token = window.localStorage.getItem('accessToken')
        if (!token) {
            setLoading(false)
            return
        }

        setLoading(true)
        setError(null)
        try {
            const { data } = await Axios.get(
                `${API_URI}/api/admin/get-counts-for-dashboard`,
                {
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                }
            )
            setDashboardData(data)
        } catch (err) {
            console.error('Error fetching dashboard data:', err)
            setError(err?.response?.data?.msg || err?.message || 'Failed to load dashboard')
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        const token = window.localStorage.getItem('accessToken')
        if (token) {
            fetchDashboard()
        } else {
            setLoading(false)
        }
    }, [fetchDashboard])

    const value = {
        dashboardData,
        loading,
        error,
        refetch: fetchDashboard,
    }

    return (
        <DashboardContext.Provider value={value}>
            {children}
        </DashboardContext.Provider>
    )
}

export default DashboardContext
